const giftComposition = () => {
  const nuxtApp = useNuxtApp()
  const { $store: store, $i18n: i18n } = nuxtApp
  const router = useRouter()
  const pathToProductpage = ({ productID, query = {} }) => {
    const path = nuxtApp.$localePath({ name: 'products-id', params: { id: productID }, query: query })
    router.push(path)
  }

  const getGiftDetail = ({ giftID, productID }) => {
    const options = {
      isVerifyAuth: true,
      giftID: giftID,
    }
    store
      .dispatch('gift/getGiftDetail', options)
      .then(res => {
        if (res.code === 0) {
          if (res.data.product_id !== productID) {
            const options = {
              productID: res.data.product_id,
              query: {
                gift_id: res.data.gift_id,
                nickname: res.data.sender_name,
              },
            }
            pathToProductpage(options)
            return true
          }
          if (res.data.is_sender) {
            const errorMessage = { message: i18n.t('recieve_gift_same_account_error') }
            throw errorMessage
          }
        } else {
          throw res
        }
      })
      .catch(error => {
        console.error('getGiftDetail:error', error)
        const confirm = () => {
          pathToProductpage({ productID: productID })
        }
        store.dispatch('dialog/setRootMessageOption', { status: true, options: { message: error.message, confirm: confirm } })
      })
  }

  return {
    getGiftDetail,
    pathToProductpage,
  }
}

export default giftComposition
